import { Platform, ViewStyle } from 'react-native'
import { createUseStyles } from '../../styles/create-use-styles'

interface LoadingPaneStyles {
  container: ViewStyle
  logo: ViewStyle
  indicator: ViewStyle
}

export const useStyles = createUseStyles<LoadingPaneStyles>((theme): LoadingPaneStyles => {
  return {
    // @ts-ignore
    container: {
      ...Platform.select({
        web: {
          position: 'fixed',
        },
        default: {
          position: 'absolute',
        },
      }),
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      flex: 1,
      backgroundColor: 'rgba(0, 0, 0, .65)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: theme.zIndex.highestLevel,
    },
    logo: {
      width: theme.calcUnit(375),
    },
    indicator: {
      marginVertical: theme.calcUnit(36),
    },
  }
})
